import styled from "styled-components";

export const ControllerSitInPlayerWrapper = styled.div`
  display: flex;
  gap: 12px;
  flex-direction: column;
  flex: 1;
  max-width: 488px;
  width: 40%;
  min-width: 0;
`;
